import { CalendarItemType } from '@akin-home/amplify';
import React, { FC } from 'react';

import CalendarListItemChatView from '../CalendarListItemView/CalendarListItemChatView';

interface Props {
  items: { item_id: string; type: CalendarItemType; recurrence_id?: string }[];
}

export const CalendarListChatItemView: FC<Props> = (props) => {
  const { items } = props;

  return (
    <>
      {items.map((item) => (
        <CalendarListItemChatView key={item.item_id} {...item} />
      ))}
    </>
  );
};
